module.exports = __webpack_public_path__ + "img/intercomscene4.f73d1835.png";